function getUnitIndex(unitList, unitId) {
  return unitList.findIndex((unit) => unit.id === unitId);
}

export function getNextUnit(state, unitId, groupId) {
  const unitList = getUnitList(state, groupId).toList();
  const index = getUnitIndex(unitList, unitId);
  return index < unitList.size - 1 ? unitList.get(index + 1) : undefined;
}

export function getPreviousUnit(state, unitId, groupId) {
  const unitList = getUnitList(state, groupId).toList();
  const index = getUnitIndex(unitList, unitId);
  return index > 0 ? unitList.get(index - 1) : undefined;
}

export function getUnitList(state, groupId) {
  const units = state.get('rootReducer').get('unit');
  if (! units) return;
  const unitsByGroup = units.get(groupId);
  if (! unitsByGroup) return;
  return unitsByGroup.sortBy((unit) => unit.orderingSequence);
}

export function getUnitNumberById(units, unitId) {
  return (units.get(unitId) && units.get(unitId).orderingSequence) || 0;
}



// WEBPACK FOOTER //
// ./data/Units/accessors.js